import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Button, Card, CardContent, Grid } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import SimpleInput from 'components/forms/SimpleInput'
import HomeAction from 'home/actions/HomeAction'

const FiltersPanel = ({
    defaultFilter = { searchValue: '' },
    onValidate = () => {},

    variant,
    sx = {},
    title, // = i18n.criterias,

    jobSync = undefined,
    color= 'white',
}) => {
    const {
        globalResearch,
    } = useSelector(store => ({
        globalResearch: store.HomeReducer.globalResearch,
    }), shallowEqual)

    const [filter, setFilter] = useState(defaultFilter)

    const dispatch = useDispatch()

    useEffect(() => {
        if (globalResearch) {
            setFilter(prev => ({ ...prev, searchValue: globalResearch }))
            dispatch(HomeAction.updateGlobalResearch(''))
        }
    }, [globalResearch])

    return (
        <Card variant={variant} sx={sx}>
            {!!title && <CardTitle title={title} color={color}/>}
            <CardContent>
                <Grid container rowSpacing={1}>
                    <Grid size={5}>
                        <SimpleInput
                            title={i18n.search}
                            value={filter.searchValue}
                            onChange={searchValue => setFilter(prev => ({ ...prev, searchValue }))}
                            onEnterKeyPress={() => onValidate(filter)}
                            data-cy='search_input'
                        />
                    </Grid>
                    {!!jobSync && (
                        <Grid size='grow'>
                            {jobSync}
                        </Grid>
                    )}
                    <Grid container size={12} columnSpacing={1} justifyContent='flex-end'>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                setFilter({})
                                onValidate({})
                            }}
                            data-cy='reset_button'
                        >
                            {i18n.reinit}
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => onValidate(filter)}
                            data-cy='search_button'
                        >
                            {i18n.search}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

FiltersPanel.propTypes = {
    defaultFilter: PropTypes.shape({
        searchValue: PropTypes.string,
    }),
    onValidate: PropTypes.func,

    variant: PropTypes.string,
    sx: PropTypes.shape({}),
    title: PropTypes.string,

    jobSync: PropTypes.element,
    color: PropTypes.string,
}

export default FiltersPanel